import { handleRedirectionWithSignupSource } from '@common/utils'
import { LazyImage } from '@components/common/image'
import router from 'next/router'
const IMAGE_PATH = '/images/competitions/'

type PropType = {
  redirectLink: string
}

const CompetitionPageBanner = ({ redirectLink }: PropType) => (
  <button
    onClick={() =>
      handleRedirectionWithSignupSource(router.asPath, redirectLink)
    }
  >
    <div className="relative cursor-pointer">
      <LazyImage
        alt="long background"
        name="long-bg-v2"
        path={IMAGE_PATH}
        className="rounded-md"
      />
      <div className="flex absolute top-0 flex-col justify-between h-full">
        <div>
          <LazyImage
            alt="codingal logo"
            name="logo"
            path={IMAGE_PATH}
            className="mx-auto mt-6 mb-8 w-24"
          />
          <div className="px-3 mx-auto mb-4 leading-5 text-center text-white font-700">
            Your key to winning hackathons &#38; coding challenges
          </div>
        </div>
        <span className="px-4 py-2 mx-auto mb-8 text-lg text-center text-white border-none btn bg-orange hover:bg-orange-500">
          Try a free lesson
        </span>
      </div>
    </div>
  </button>
)

export default CompetitionPageBanner
